<div>
  <app-contacts-list class="contact-list" (openDetails)="openDialogDetails($event)"></app-contacts-list>

  <app-contact-details 
    class="contact-details" 
    [ngClass]="{'open': detailsOpen && currentContact}"
    *ngIf="detailsOpen && currentContact;else detailStart" 
    [contact]="currentContact" 
    (contactDeleted)="handleContactDeleted()"
    #contactDetailsComponent
    (closeDetails)="detailsOpen = false">

  </app-contact-details>

  <ng-template #detailStart>
    <app-contact-details class="contact-details"></app-contact-details>
  </ng-template>
</div>